<template>
  <Modal :id="id" :title="title || `Import File`" :hideFooter="true">
    <div slot="body" class="modal-body">
      <div
        v-if="!!errorMessage"
        class="alert alert-danger"
        v-html="errorMessage"
      ></div>
      <p v-if="!!sampleFile">
        Download this
        <a :href="sampleFile" class="text-primary">sample file</a> to use as a
        template for your import file.
      </p>
      <div class="dropzone" :id="dropzoneId">
        <div class="text-center">
          <button type="button" class="btn btn-primary">Choose File</button>
        </div>
        <div class="dropzone-preview mt-3"></div>
      </div>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
import Dropzone from "dropzone";
export default {
  mixins: [ModalMixin],

  data() {
    return {
      id: "file-import-modal",
      dropzoneId: "dz-file-import",
      dropzoneUrl: null,
      errorMessage: null,
    };
  },

  computed: {
    sampleFile() {
      return _.has(this.options, "sample_file")
        ? this.options.sample_file
        : null;
    },
  },

  methods: {
    initDropzone() {
      let token = document.head.querySelector('meta[name="csrf-token"]');
      Dropzone.autoDiscover = false;

      this.dropzone = new Dropzone(`#${this.dropzoneId}`, {
        url: this.dropzoneUrl,
        paramName: "import_file",
        withCredentials: true,
        headers: { "X-CSRF-Token": token.content },
        clickable: `#${this.dropzoneId} button`,
        previewsContainer: `#${this.dropzoneId} .dropzone-preview`,
        hiddenInputContainer: `#${this.dropzoneId} .dropzone-preview`,
        thumbnailMethod: "contain",
      });

      let me = this;
      this.dropzone.on("success", (file, response) => {
        setTimeout(() => {
          me.dropzone.removeFile(file);
          me.resolve();
        }, 3000);
      });

      this.dropzone.on("error", (file, response) => {
        if (
          _.isObject(response) &&
          _.has(response, "errors") &&
          _.isArray(response.errors)
        ) {
          me.errorMessage = "<p>The following errors occurred:</p><ul>";
          response.errors.forEach((errors) => {
            me.errorMessage += "<li>" + errors.join("</li><li>") + "</li>";
          });
          me.errorMessage += "</ul>";
        } else {
          me.errorMessage = `<p class="mb-0">An unexpected error occurred.</p>`;
        }
      });
    },
  },

  mounted() {
    if (!_.has(this.options, "import_url") || !this.options.import_url) {
      this.error = "ERROR: no import URL specified";
    } else {
      this.dropzoneUrl = this.options.import_url;
      this.initDropzone();
    }
  },
};
</script>

<style>
#dz-file-import {
  border: none;
  min-height: 0;
  padding: 0;
}
</style>
